import { set, toggle } from '@/utils/vuex'

export default {
  setStepper: set('stepper'),
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer')
}
